import { Routes, Route, Navigate } from 'react-router-dom'

// Layouts
import DashboardLayout from '@/components/layouts/DashboardLayout'
import AdminLayout from '@/components/layouts/AdminLayout'
import AuthLayout from '@/components/layouts/AuthLayout'

// Auth pages
import LoginPage from '@/pages/login'
import SignupPage from '@/pages/signup'

// Customer pages
import LandingPage from '@/pages/index'
import VsGoogleAnalytics from '@/pages/vs-google-analytics'
import ForShopify from '@/pages/for-shopify'
import ForWordpress from '@/pages/for-wordpress'
import BestWebsiteAnalytics from '@/pages/best-website-analytics'
import DashboardPage from '@/pages/dashboard'
import VisitorsPage from '@/pages/visitors'
import SessionsPage from '@/pages/sessions/index'
import SessionDetailPage from '@/pages/sessions/[id]'
import ExplorerPage from '@/pages/explorer'
import SettingsPage from '@/pages/settings'
import InsightsPage from '@/pages/insights'

// Admin pages
import AdminOverviewPage from '@/pages/admin/index'
import AdminUsersPage from '@/pages/admin/users/index'
import AdminUserDetailPage from '@/pages/admin/users/[id]'
import AdminSitesPage from '@/pages/admin/sites'
import AdminBillingPage from '@/pages/admin/billing'
import AdminSystemPage from '@/pages/admin/system'
import AdminAbusePage from '@/pages/admin/abuse'

// Guards
import AuthGuard from '@/components/auth/AuthGuard'
import AdminGuard from '@/components/admin/AdminGuard'

function App() {
  return (
    <Routes>
      {/* Public routes - don't wait for auth */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/vs-google-analytics" element={<VsGoogleAnalytics />} />
      <Route path="/for-shopify" element={<ForShopify />} />
      <Route path="/for-wordpress" element={<ForWordpress />} />
      <Route path="/best-website-analytics" element={<BestWebsiteAnalytics />} />

      {/* Auth routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
      </Route>

      {/* Protected customer routes */}
      <Route element={<AuthGuard><DashboardLayout /></AuthGuard>}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/visitors" element={<VisitorsPage />} />
        <Route path="/sessions" element={<SessionsPage />} />
        <Route path="/sessions/:id" element={<SessionDetailPage />} />
        <Route path="/explorer" element={<ExplorerPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      {/* Admin routes */}
      <Route element={<AdminGuard><AdminLayout /></AdminGuard>}>
        <Route path="/admin" element={<AdminOverviewPage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/users/:id" element={<AdminUserDetailPage />} />
        <Route path="/admin/sites" element={<AdminSitesPage />} />
        <Route path="/admin/billing" element={<AdminBillingPage />} />
        <Route path="/admin/system" element={<AdminSystemPage />} />
        <Route path="/admin/abuse" element={<AdminAbusePage />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
